// Translation strings for CZ, EN, ES
export const translations = {
  cs: {
    nav: {
      about: "O studiu",
      services: "Služby",
      gallery: "Ukázky prací",
      process: "Realizace",
      contact: "Kontakt",
      cta: "Nezávazná poptávka",
    },
    hero: {
      eyebrow: "Materiálový ateliér pro interiérové stěny",
      title_line1: "Stěny, které nesou tíhu",
      title_line2: "kamene a klid",
      title_line3: "betonu.",
      subtitle:
        "Tervalia tvoří dekorativní skalní stěny, reliéfní betonové povrchy a ručně tvarované stěny inspirované kamenem — každý kus vzniká ručně, na míru prostoru, kterému má dodat hloubku.",
      cta_primary: "Naše služby",
      cta_secondary: "Ukázky prací",
      founded_label: "Založeno 2026",
      founded_sub: "Dekorativní betonové a kamenné stěny pro interiér",
    },
    about: {
      eyebrow: "O studiu",
      title: "Ateliér pro syrový materiál a tichý záměr.",
      p1: "Tervalia je malé studio s jednou myšlenkou: interiérová stěna může působit jako kus geologie — vrstvená, nepravidelná, živá.",
      p2: "Pracujeme s betonem, minerálními pigmenty a tradičními hladicími technikami. Tvarujeme povrchy, které připomínají skalní stěny, řečiště a zvětralý kámen. Každý panel vzniká přímo na stavbě — nikdy se neopakuje, nikdy se netiskne.",
      benefits: {
        b1: "Ručně tvořené",
        b2: "Každý kus originál",
        b3: "Navrženo pro interiér",
      },
    },
    services: {
      eyebrow: "Co tvoříme",
      title: "Tři disciplíny, jedna posedlost texturou.",
      cta: "Nezávazná poptávka",
      items: [
        {
          n: "01",
          title: "Dekorativní skalní stěny",
          text: "Monolitické dominanty místnosti odlévané a vyřezávané přímo na stavbě. Silný reliéf, hluboké stíny a syrová přítomnost minerálu.",
        },
        {
          n: "02",
          title: "Reliéfní betonové povrchy",
          text: "Hmatové povrchy na míru pro byty, domy a hotelové prostory — od jemně tvarovaných ploch až po výrazné sochařské reliéfy.",
        },
        {
          n: "03",
          title: "Ručně tvořené stěny inspirované kamenem",
          text: "Stěny odkazující na přírodní formace — čedič, travertin, vápenec — bez tíhy a nákladů masivního kamene. Pro interiér i vybrané exteriéry.",
        },
      ],
    },
    gallery: {
      eyebrow: "Ukázky prací",
      title: "Vzorky a připravované realizace.",
      subtitle:
        "Výběr textur a povrchových úprav. Nové projekty a fotodokumentace ze staveb budou přibývat postupně, jak budou dokončovány.",
      items: [
        { title: "Pískový reliéfní povrch", meta: "Beton · pískový pigment", code: "TR · 01" },
        { title: "Vyřezávaný betonový reliéf", meta: "Beton · ručně vyřezáváno", code: "TR · 02" },
        { title: "Detail surového betonu", meta: "Beton · syrový povrch", code: "TR · 03" },
        { title: "Kamenná textura na míru", meta: "Minerální pigment · ruční modelace", code: "TR · 04" },
        { title: "Strukturovaný kamenný reliéf", meta: "Beton · ruční textura", code: "TR · 05" },
      ],
    },
    process: {
      eyebrow: "Jak probíhá realizace",
      title: "Od prvního rozhovoru po hotovou stěnu.",
      steps: [
        {
          n: "01",
          title: "Rozhovor",
          text: "Sejdeme se přímo u vás nebo on-line, abychom porozuměli prostoru, světlu a textuře, kterou máte na mysli.",
        },
        {
          n: "02",
          title: "Vzorek a koncept",
          text: "Vyrobíme fyzický vzorkový panel — vaši referenci pro barvu, hloubku a povrch — dříve, než se začne pracovat na samotné stěně.",
        },
        {
          n: "03",
          title: "Realizace na místě",
          text: "Stěnu budujeme po vrstvách a ručně sochaříme po několik dní. Pracujeme s minimem prachu a co nejmenším narušením provozu.",
        },
        {
          n: "04",
          title: "Impregnace a předání",
          text: "Finální patina, minerální impregnace a stručný návod k péči, aby povrch stárl přesně tak, jak má.",
        },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Často kladené dotazy",
      subtitle: "Vše, co potřebujete vědět před prvním projektem.",
      items: [
        {
          q: "Kde se dají vaše stěny použít?",
          a: "Naše dekorativní povrchy se hodí do obytných i komerčních interiérů — obývacích pokojů, ložnic, recepcí, hotelů, restaurací, butiků či showroomů. Vybraná řešení zvládneme navrhnout i do krytých částí exteriéru, například do zádveří, atria nebo zahradní stěny.",
        },
        {
          q: "Jak probíhá samotná realizace?",
          a: "Začínáme rozhovorem o prostoru, světle, požadované textuře a atmosféře. Poté připravíme vzorek nebo koncept povrchu. Samotná realizace probíhá po vrstvách přímo na místě — od přípravy podkladu přes ruční modelaci až po patinu, impregnaci a předání.",
        },
        {
          q: "Jak dlouho trvá realizace jedné stěny?",
          a: "Záleží na velikosti plochy, hloubce reliéfu a složitosti výsledné textury. Menší stěny obvykle zabírají několik pracovních dní, výraznější plastické povrchy nebo větší realizace řešíme individuálně podle konkrétního prostoru.",
        },
        {
          q: "Lze udělat povrch přesně na míru?",
          a: "Ano. Každý povrch vzniká ručně a lze ho přizpůsobit barvou, hloubkou, strukturou i celkovým charakterem. Před realizací můžeme připravit vzorkový panel, podle kterého se doladí odstín, reliéf i finální výraz stěny.",
        },
        {
          q: "Jak povrch stárne a jak se o něj starat?",
          a: "Finální povrch chrání minerální impregnace. Běžná údržba je jednoduchá — stačí jemné otření prachu nebo nečistot měkkým hadříkem. Nedoporučujeme abrazivní houbičky ani agresivní chemii. Povrch by měl přirozeně zrát a zachovat si svou strukturu.",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Povězte nám o svém prostoru.",
      subtitle:
        "Napište pár řádků o projektu — místnost, plocha, atmosféra, případně reference — a do 1–2 pracovních dnů se vám ozveme s dalšími kroky.",
      founder: "Lukáš Czolko — zakladatel",
      form: {
        name: "Jméno",
        phone: "Telefon",
        email: "E-mail",
        details: "Detaily projektu (volitelné)",
        message: "Zpráva",
        placeholder: "Místnost, plocha, představa o povrchu, reference…",
        required: "Povinné pole",
        invalid_email: "Neplatný e-mail",
        submit: "Odeslat poptávku",
        submitting: "Odesílám…",
        success:
          "Děkujeme za zprávu. Ozveme se během 1–2 pracovních dnů.",
        error:
          "Odeslání se nezdařilo. Zkuste to prosím znovu nebo nás kontaktujte přímo.",
      },
      footer: "© 2026 Tervalia. Materiálový ateliér pro interiérové stěny.",
    },
  },

  en: {
    nav: {
      about: "Studio",
      services: "Services",
      gallery: "Work",
      process: "Process",
      contact: "Contact",
      cta: "Request quote",
    },
    hero: {
      eyebrow: "Material atelier for interior walls",
      title_line1: "Walls that carry the weight",
      title_line2: "of stone and the calm",
      title_line3: "of concrete.",
      subtitle:
        "Tervalia designs decorative rock walls, sculpted concrete surfaces and hand-shaped walls inspired by stone — each piece made by hand, tailored to the space it is meant to give depth.",
      cta_primary: "Our services",
      cta_secondary: "See our work",
      founded_label: "Founded 2026",
      founded_sub: "Decorative concrete and stone walls for interior",
    },
    about: {
      eyebrow: "About the studio",
      title: "An atelier for raw material and quiet intent.",
      p1: "Tervalia is a small studio with one idea: an interior wall can feel like a piece of geology — layered, irregular, alive.",
      p2: "We work with concrete, mineral pigments and traditional troweling techniques. We shape surfaces that recall rock walls, riverbeds and weathered stone. Every panel is built on-site — never repeated, never printed.",
      benefits: {
        b1: "Hand-crafted",
        b2: "Every piece original",
        b3: "Designed for interior",
      },
    },
    services: {
      eyebrow: "What we make",
      title: "Three disciplines, one obsession with texture.",
      cta: "Request quote",
      items: [
        {
          n: "01",
          title: "Decorative rock walls",
          text: "Monolithic room-defining walls cast and carved on-site. Strong relief, deep shadows and the raw presence of mineral.",
        },
        {
          n: "02",
          title: "Sculpted concrete surfaces",
          text: "Tactile bespoke surfaces for apartments, homes and hotel spaces — from gently modelled planes to bold sculptural reliefs.",
        },
        {
          n: "03",
          title: "Hand-shaped stone-inspired walls",
          text: "Walls that echo natural formations — basalt, travertine, limestone — without the weight and cost of solid stone. For interior and selected exteriors.",
        },
      ],
    },
    gallery: {
      eyebrow: "Our work",
      title: "Samples and upcoming projects.",
      subtitle:
        "A selection of textures and surface treatments. New projects and photography from the studio will be added as they are completed.",
      items: [
        { title: "Sand relief surface", meta: "Concrete · sand pigment", code: "TR · 01" },
        { title: "Carved concrete relief", meta: "Concrete · hand-carved", code: "TR · 02" },
        { title: "Raw concrete detail", meta: "Concrete · raw surface", code: "TR · 03" },
        { title: "Bespoke stone texture", meta: "Mineral pigment · hand modelled", code: "TR · 04" },
        { title: "Structured stone relief", meta: "Concrete · hand-worked texture", code: "TR · 05" },
      ],
    },
    process: {
      eyebrow: "How we work",
      title: "From the first conversation to a finished wall.",
      steps: [
        { n: "01", title: "Conversation", text: "We meet at your space or online to understand the room, the light and the texture you have in mind." },
        { n: "02", title: "Sample & concept", text: "We prepare a physical sample panel — your reference for colour, depth and surface — before any work on the wall itself begins." },
        { n: "03", title: "On-site build", text: "The wall is built in layers and hand-sculpted over several days. We work with minimal dust and the least possible disruption." },
        { n: "04", title: "Sealing & handover", text: "Final patina, mineral sealer and a short care guide so the surface ages exactly the way it should." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      subtitle: "Everything you might want to know before your first project.",
      items: [
        { q: "Where can your walls be installed?", a: "Our decorative surfaces are suited to residential and commercial interiors — living rooms, bedrooms, receptions, hotels, restaurants, boutiques and showrooms. Selected treatments also work in sheltered exteriors, such as entryways, atriums or garden walls." },
        { q: "How is a wall actually made?", a: "We start with a conversation about the space, light, texture and atmosphere you want. We then prepare a sample or concept. The wall itself is built in layers directly on-site — from substrate preparation through hand-modelling to patina, sealing and handover." },
        { q: "How long does a wall take to complete?", a: "It depends on the size, the depth of the relief and the complexity of the final texture. Smaller walls usually take a few working days; more sculptural surfaces or larger areas are quoted individually per space." },
        { q: "Can the surface be made to measure?", a: "Yes. Every surface is made by hand and can be tailored in colour, depth, structure and overall character. A sample panel can be prepared before we start, so the shade, relief and final look can be fine-tuned." },
        { q: "How does the surface age and how do I care for it?", a: "The final surface is protected by a mineral sealer. Everyday care is simple — a soft cloth to remove dust or marks. Avoid abrasive sponges and aggressive chemicals. The surface should mature naturally and keep its texture." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Tell us about your space.",
      subtitle:
        "Write a few lines about the project — the room, the area, the atmosphere, references if you have them — and we will get back to you within 1–2 working days.",
      founder: "Lukáš Czolko — founder",
      form: {
        name: "Name",
        phone: "Phone",
        email: "E-mail",
        details: "Project details (optional)",
        message: "Message",
        placeholder: "Room, surface area, texture idea, references…",
        required: "Required field",
        invalid_email: "Invalid e-mail",
        submit: "Send inquiry",
        submitting: "Sending…",
        success: "Thank you. We will get back to you within 1–2 working days.",
        error: "Something went wrong. Please try again or contact us directly.",
      },
      footer: "© 2026 Tervalia. Material atelier for interior walls.",
    },
  },

  es: {
    nav: {
      about: "Estudio",
      services: "Servicios",
      gallery: "Trabajos",
      process: "Proceso",
      contact: "Contacto",
      cta: "Solicitar presupuesto",
    },
    hero: {
      eyebrow: "Atelier de materiales para muros interiores",
      title_line1: "Muros que llevan el peso",
      title_line2: "de la piedra y la calma",
      title_line3: "del hormigón.",
      subtitle:
        "Tervalia crea muros decorativos de roca, superficies escultóricas de hormigón y paredes moldeadas a mano inspiradas en la piedra — cada pieza se hace a mano, adaptada al espacio al que debe dar profundidad.",
      cta_primary: "Nuestros servicios",
      cta_secondary: "Ver trabajos",
      founded_label: "Fundado 2026",
      founded_sub: "Muros decorativos de hormigón y piedra para interior",
    },
    about: {
      eyebrow: "Sobre el estudio",
      title: "Un atelier de materia bruta y silencio intencionado.",
      p1: "Tervalia es un pequeño estudio con una única idea: un muro interior puede sentirse como un fragmento de geología — estratificado, irregular, vivo.",
      p2: "Trabajamos con hormigón, pigmentos minerales y técnicas tradicionales de fratasado. Modelamos superficies que evocan paredes de roca, cauces y piedra erosionada. Cada panel se construye en obra — nunca se repite, nunca se imprime.",
      benefits: {
        b1: "Hecho a mano",
        b2: "Cada pieza única",
        b3: "Diseñado para interior",
      },
    },
    services: {
      eyebrow: "Qué creamos",
      title: "Tres disciplinas, una obsesión por la textura.",
      cta: "Solicitar presupuesto",
      items: [
        { n: "01", title: "Muros decorativos de roca", text: "Piezas monolíticas que definen la sala, moldeadas y talladas directamente en obra. Relieve profundo, sombras densas y la presencia cruda del mineral." },
        { n: "02", title: "Superficies escultóricas de hormigón", text: "Superficies táctiles a medida para viviendas, hoteles y espacios comerciales — desde planos suavemente modelados hasta relieves escultóricos." },
        { n: "03", title: "Muros hechos a mano inspirados en la piedra", text: "Paredes que evocan formaciones naturales — basalto, travertino, caliza — sin el peso ni el coste de la piedra maciza. Para interior y exteriores seleccionados." },
      ],
    },
    gallery: {
      eyebrow: "Trabajos",
      title: "Muestras y proyectos en curso.",
      subtitle:
        "Una selección de texturas y acabados. Se irán incorporando nuevos proyectos y fotografías a medida que se completen.",
      items: [
        { title: "Superficie de relieve arena", meta: "Hormigón · pigmento arena", code: "TR · 01" },
        { title: "Relieve tallado en hormigón", meta: "Hormigón · tallado a mano", code: "TR · 02" },
        { title: "Detalle de hormigón crudo", meta: "Hormigón · superficie cruda", code: "TR · 03" },
        { title: "Textura de piedra a medida", meta: "Pigmento mineral · modelado manual", code: "TR · 04" },
        { title: "Relieve estructurado de piedra", meta: "Hormigón · textura manual", code: "TR · 05" },
      ],
    },
    process: {
      eyebrow: "Cómo trabajamos",
      title: "De la primera conversación al muro terminado.",
      steps: [
        { n: "01", title: "Conversación", text: "Nos vemos en el espacio o en línea para entender la sala, la luz y la textura que tenéis en mente." },
        { n: "02", title: "Muestra y concepto", text: "Preparamos un panel de muestra físico — vuestra referencia de color, profundidad y superficie — antes de empezar sobre el muro." },
        { n: "03", title: "Ejecución en obra", text: "El muro se levanta por capas y se esculpe a mano durante varios días. Trabajamos con el mínimo polvo y la menor interrupción posible." },
        { n: "04", title: "Sellado y entrega", text: "Pátina final, sellador mineral y una breve guía de cuidados para que la superficie envejezca justo como debe." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que podéis querer saber antes del primer proyecto.",
      items: [
        { q: "¿Dónde se pueden instalar vuestros muros?", a: "Nuestras superficies decorativas encajan tanto en interiores residenciales como comerciales — salas de estar, dormitorios, recepciones, hoteles, restaurantes, boutiques y showrooms. Ciertos acabados también funcionan en exteriores cubiertos, como zaguanes, atrios o muros de jardín." },
        { q: "¿Cómo se hace un muro?", a: "Empezamos con una conversación sobre el espacio, la luz, la textura y la atmósfera. Después preparamos una muestra o concepto. La ejecución se hace por capas directamente en obra — desde la preparación del soporte, pasando por el modelado a mano, hasta la pátina, el sellado y la entrega." },
        { q: "¿Cuánto tarda un muro?", a: "Depende del tamaño, la profundidad del relieve y la complejidad de la textura final. Los muros más pequeños suelen requerir unos días de trabajo; las superficies más escultóricas o mayores se cotizan de forma individual." },
        { q: "¿Se puede hacer a medida?", a: "Sí. Cada superficie se realiza a mano y puede adaptarse en color, profundidad, estructura y carácter general. Antes de la ejecución podemos preparar un panel de muestra para afinar el tono, el relieve y el aspecto final." },
        { q: "¿Cómo envejece y cómo se cuida?", a: "La superficie final se protege con un sellador mineral. El mantenimiento diario es sencillo — basta un paño suave para retirar polvo o manchas. Evitad esponjas abrasivas y productos agresivos. La superficie debe madurar con naturalidad y conservar su textura." },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "Contadnos sobre vuestro espacio.",
      subtitle:
        "Escribid unas líneas sobre el proyecto — la sala, la superficie, la atmósfera, referencias si las tenéis — y os responderemos en 1–2 días laborables.",
      founder: "Lukáš Czolko — fundador",
      form: {
        name: "Nombre",
        phone: "Teléfono",
        email: "E-mail",
        details: "Detalles del proyecto (opcional)",
        message: "Mensaje",
        placeholder: "Sala, superficie, idea de textura, referencias…",
        required: "Campo obligatorio",
        invalid_email: "E-mail no válido",
        submit: "Enviar solicitud",
        submitting: "Enviando…",
        success: "Gracias. Os responderemos en 1–2 días laborables.",
        error: "El envío no se ha completado. Inténtenlo de nuevo o escribidnos directamente.",
      },
      footer: "© 2026 Tervalia. Atelier de materiales para muros interiores.",
    },
  },
};

export const LOCALES = ["cs", "en", "es"];
